import { Component, computed, input, output, Signal } from '@angular/core';
import { VisualField } from '../../../VisualField';
import { SortDirection } from 'src/app/services/api.services';

@Component({
  selector: 'app-pivot-table-column-header',
  templateUrl: './ColumnHeader.component.html',
  styleUrl: './ColumnHeader.component.scss',
  host: {
    'class': 'column-group-header column-group-header-column',
    '[attr.title]': 'visualField().shortTitle',
    '(click)': 'clicked.emit($event)',
    '(contextmenu)': 'contextMenu.emit($event)',
    '[attr.data-testid]':'datatestid()'
  }
})
export class PivotColumnHeader {
  readonly datatestid = computed(() => `column-group-header-${this.visualField().target.referenceString()}`);

  readonly visualField = input.required<VisualField>();

  readonly sortingAscending = computed(() => this.visualField().sortDirection() == SortDirection.Ascending);

  readonly ellipsisClick = output<MouseEvent>();

  readonly contextMenu = output<MouseEvent>();

  readonly clicked = output<MouseEvent>();
}
